var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "AddNewDestinationToGroup"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("Add New Destinations")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Group City"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-home'></i>"
    }
  }, [_c('b-input-group', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    attrs: {
      "options": _vm.cityList,
      "name": "destinationcityid",
      "label": "text",
      "track-by": "text",
      "placeholder": "Select Destination City",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clear-on-select": false,
      "limit": 1
    },
    on: {
      "select": _vm.selectedDestination
    },
    model: {
      value: (_vm.destinationcityid),
      callback: function($$v) {
        _vm.destinationcityid = $$v
      },
      expression: "destinationcityid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationcityid')),
      expression: "errors.has('destinationcityid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The destinationcityid field is\n                    required.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.cityLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Group"), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-group'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('groupid')
    },
    attrs: {
      "options": _vm.groupList,
      "selected-option": _vm.groupTypeObjData,
      "name": "groupid",
      "placeholder": "Select Group"
    },
    on: {
      "select": _vm.selectedGroupType
    },
    model: {
      value: (_vm.groupid),
      callback: function($$v) {
        _vm.groupid = $$v
      },
      expression: "groupid"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('groupid')),
      expression: "errors.has('groupid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('groupid')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Clear")])])], 1)], 1)]), _vm._v(" \n              "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    style: (("" + ((_vm.DestList.length>0) ? 'overflow: auto; height: 450px;':'overflow: auto; height: 200px;')))
  }, [_c('fieldset', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [(_vm.showList == true) ? _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('model-select', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "options": _vm.listHubZoneData,
      "name": "hubzoneid",
      "title": "Select Zone",
      "placeholder": "Select Zone"
    },
    on: {
      "input": function($event) {
        return _vm.selectedZone()
      }
    },
    model: {
      value: (_vm.hubzoneid),
      callback: function($$v) {
        _vm.hubzoneid = $$v
      },
      expression: "hubzoneid"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.zoneLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.showList == true) ? _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listHubData,
      "name": "hubid",
      "id": "value",
      "label": "text",
      "track-by": "value",
      "placeholder": "Select Hub",
      "show-labels": false,
      "multiple": false,
      "max-height": 300,
      "clear-on-select": true
    },
    on: {
      "select": _vm.selectedHub
    },
    model: {
      value: (_vm.hubList),
      callback: function($$v) {
        _vm.hubList = $$v
      },
      expression: "hubList"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1), _vm._v(" "), (_vm.showList == true) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticClass: "text-center",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px",
      "float": "left",
      "margin-top": "7px"
    },
    on: {
      "click": function($event) {
        return _vm.resetZoneHub()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "title": "Reset Zone/Hub"
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.destinationLoading
    },
    on: {
      "update:active": function($event) {
        _vm.destinationLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    class: ("" + ((_vm.DestList.length>0) ? 'showdest' : '')),
    style: (("" + ((_vm.DestList.length>0) ? 'margin-top: 1%;height: 330px;' : 'margin-top: 1%;overflow:auto; min-height:auto;')))
  }, [_c('table', {
    staticClass: "table-hover datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader",
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllHub),
      expression: "checkAllHub"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "10px"
    },
    attrs: {
      "type": "checkbox",
      "id": "all",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllHub) ? _vm._i(_vm.checkAllHub, null) > -1 : (_vm.checkAllHub)
    },
    on: {
      "click": _vm.checkHub,
      "change": function($event) {
        var $$a = _vm.checkAllHub,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllHub = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllHub = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllHub = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "all"
    }
  }, [_vm._v(" Select All")])])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "z-index": "-1"
    }
  }, [_vm._l((_vm.DestList), function(destination) {
    return _c('tr', _vm._l((destination), function(hub, index) {
      return _c('td', [_c('input', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "checkbox",
          "id": hub.hubId
        },
        domProps: {
          "checked": _vm.checkedHub[hub.hubId]
        },
        on: {
          "change": _vm.updateCheckDest
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "for": hub.hubId
        }
      }, [_vm._v(" " + _vm._s(hub.hubName) + "\n                                  (" + _vm._s(hub.hubId) + ")")])])
    }), 0)
  }), _vm._v(" "), (_vm.DestList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])]), _vm._v(" "), _c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingtable
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingtable = $event
      }
    }
  }), _vm._v(" "), _c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("List Of Mapped Connection")]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHub('hubsave')
      }
    }
  }, [_c('div', {
    style: (_vm.connectionList.length > 10 ? 'overflow: auto; height: 380px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "height": "10px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllConnection),
      expression: "checkAllConnection"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "0.5%"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllConnection) ? _vm._i(_vm.checkAllConnection, null) > -1 : (_vm.checkAllConnection)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkAllConnection,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllConnection = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllConnection = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllConnection = $$c
        }
      }, function($event) {
        return _vm.checkConnections()
      }]
    }
  })]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bagging Pattern")])])]), _vm._v(" "), _c('tbody', [(_vm.connectionList.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.connectionList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.isselected),
        expression: "data.isselected"
      }],
      staticStyle: {
        "cursor": "pointer",
        "margin-left": "0.5%"
      },
      attrs: {
        "type": "checkbox",
        "id": "all"
      },
      domProps: {
        "checked": Array.isArray(data.isselected) ? _vm._i(data.isselected, null) > -1 : (data.isselected)
      },
      on: {
        "change": [function($event) {
          var $$a = data.isselected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(data, "isselected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(data, "isselected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(data, "isselected", $$c)
          }
        }, function($event) {
          return _vm.updateConnectionList()
        }]
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parenthubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtypes))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.isbaggingpattern))])])
  })], 2)])]), _vm._v(" "), (_vm.connectionList.length > 0) ? _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "padding": "0.25rem"
    }
  }, [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-left": "90%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])]) : _vm._e()])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.confirmationModal = false
      }
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Destinations will be mapped to the Group for selected connections. Do you want to proceed?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mapMultipleDestinationsToConnection
    }
  }, [_vm._v("Save Changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])], 1)])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a1cf770","hasScoped":true}!./src/views/components/groupnew/AddNewDestinationToGroup/AddNewDestinationToGroup.html
// module id = 1934
// module chunks = 2